import Vue from "vue";
import Vuex from "vuex";


Vue.use(Vuex);



const state = {
    OptionList:[],//模板内容
    OptionNextList:[],//追问调优内容
    ClassReviewContent:'',//课评结果内容
    ClassOptUser:'',//追问使用
    ClassModelCode:'',//模板code

    ParaTypeList:[],//类目列表

    QuickTypeList:[],//快捷类目列表
    OtherTypeList:[],//其他类目列表

    isAccount: JSON.parse(window.localStorage.getItem("isAccount")) || false, // 帐号是否异常
    userOtherInfo: JSON.parse(window.localStorage.getItem("userOtherInfo")) || {},
    userInfo: JSON.parse(window.localStorage.getItem("weChatGather")) || {},
    userMember: JSON.parse(window.localStorage.getItem("userMember")) || {},
    userMenu: JSON.parse(window.localStorage.getItem("userMenu")) || [],
    isLogin: JSON.parse(window.localStorage.getItem("isLogin")) || false,
    defaultShopInfo: JSON.parse(window.localStorage.getItem("defaultShopInfo")) || {},//初始默认门店数据
    DefaultFirstShopInfo: '',//第一个门店数据
    UserShopList: JSON.parse(window.localStorage.getItem("UserShopList")) || [],//用户门店列表数据
    UserShopCount:1,//当前用户门店数量
    hasCustomer: false,
    hiddenTabBar: false,
    TagData:[],//商机标签数据
    CustomTagData:[],//自定义标签数据
    FollowTagData:'',//跟进标签字典数据
    NeedData:[],//需求标签字典数据
    IntentionData:[],//意向标签数据
    DistanceData:[],//距离标签数据
    CustomerSource:[],//获取来源标签数据

    shopCode:'',//机构管理员选择的用户门店code 先写死 后期赋值
    shopName:'',//机构管理员选择的门店名称 先写死 后期赋值
    roleName:'',//用户角色
    roleCode:'',//角色code
    userName:'',//用户姓名
    isCustomRole:false,  // 是否自定义角色
    DataViewCount:{
        cjje:0,//成交金额
        cjjesytq:0,//成交金额上月同期
        zjxy:0,//在籍学员
        zjxysytq:0,//在籍学员上月同期
        businessCount:0,//商机数量
        businessAdd:0,//商机数量增加
        studentCount:0,//学员数量
        studentAdd:0,//学员数量增加
        highseasCount:0,//公海数量
        highseasAdd:0,//公海数量增加
        attendanceCount:0,//出勤数量
        attendanceCountForMonth:0,//出勤数量增加
        renewStudentCount:0,//续费数量
        renewStudentCountForMonth:0,//续费数量增加
    },//数据预览缓存存储
    BusinessParam:{},//商机
    BearParm:{
        DdbqPage:{},//待打标签
        DystPage:{},//待约试听
        JxfkPage:{},//教学反馈
        JjxfPage:{},//即将续费
        CmxyPage:{},//沉默学员
        SrwhPage:{},//生日问候
        QfxyPage:{},//欠费学员
        LskhPage:{},//流失学员
    },//熊ai列表分页参数缓存
    PageParam:{},//通用列表参数缓存
    StudentParam:{},//学员入参
    HighSeasParam:{},//公海参数缓存
    PostersParam: {},//海报列表缓存参数
    CustomerInfo: {},//约试听课客户信息
    StudentInfo: {},//代约课学员信息
    ClassUpdateInfo: {},//调课修改信息存储
    SelectStudent: {},//选择的学员信息
    SelectCourse: {},//选择的课程信息
    askForLeaveInfo: {}, //代约课选择的课程
    MergesList: [],//相似商机合并列表
    MergesSelect: [],//选择的相似商机合并数据
    externalContacts: '', //外部联系人 userId
    PostersOption: [],//海报配置项
    SpaceBookHourList: [],//场地预订时间段存储
    MergesCurrent: {},//商机详情底部更多操作 合并  当前学员信息存储
    BearAiHeight: 0,//熊ai滚动条高度记录
    valetBookingInfo: {},
    isArrears: window.localStorage.getItem("isArrears") || '', // 机构是否允许欠费  0 不允许欠费  1允许欠费
    login_source:window.localStorage.getItem("login_source") ||''   // 登录方式  mobile：手机号登录    micro：企业微信
};
const mutations = {
    handleUserInfo: (state, userInfo) => {
        state.userInfo = userInfo || {};
        // 把登录的用户的名保存到localStorage中，防止页面刷新，导致vuex重新启动，用户名就成为初始值（初始值为空）的情况
        localStorage.setItem("weChatGather", JSON.stringify(userInfo));
    },
    handleOtherUserInfo: (state, userOtherInfo) => {
        state.userOtherInfo = userOtherInfo || {};
        localStorage.setItem("userOtherInfo", JSON.stringify(userOtherInfo));
    },

    //设置登录方式
    handleLogin_source: (state, sourcetype) => {
        state.login_source = sourcetype||'';
        // 把登录方式 保存到localStorage中，防止页面刷新，导致vuex重新启动，用户名就成为初始值（初始值为空）的情况
        localStorage.setItem("login_source", sourcetype);
    },
    // 修改登录状态
    changeLogin(state, status) {
        state.isLogin = status;
        localStorage.setItem("isLogin", JSON.stringify(status));
    },
    // 帐号状态是否异常  默认 false
    CHANGE_ACCOUNT(state, status) {
        state.isAccount = status;
        localStorage.setItem("isAccount", JSON.stringify(status));
    },
    // 修改 客服图标 显示
    CHANGE_CUSTOMER(state, status) {
        state.hasCustomer = status;
    },
    // 修改 tabBar 显示
    CHANGE_TAB_BAR_STATUS(state, status) {
        this.state.hiddenTabBar = status;
    },
    //获取并更新商机tag标签数据
    CHANGE_BUSINESS_TAG_DATA(state,list)
    {

        state.TagData=list;
        for(let i=0;i<list.length;i++)
        {
            //客户来源
            if(list[i].key=='customerSource')
            {

                var childlist=[];
                for(let j=0;j<list[i].getSysDictVoList.length;j++)
                {
                    var obj={
                        text:list[i].getSysDictVoList[j].label,
                        value:list[i].getSysDictVoList[j].value,
                    };
                    childlist.push(obj);
                }

                state.CustomerSource=childlist;
            }

            //意向标签
            if(list[i].key=='planTag')
            {

                let childlist=[];
                for(let j=0;j<list[i].getSysDictVoList.length;j++)
                {
                    var obj={
                        text:list[i].getSysDictVoList[j].label,
                        value:list[i].getSysDictVoList[j].value,
                    };
                    childlist.push(obj);
                }

                state.IntentionData=childlist;
            }

            //需求标签
            if(list[i].key=='needTag')
            {

                let childlist=[];
                for(let j=0;j<list[i].getSysDictVoList.length;j++)
                {
                    var obj={
                        text:list[i].getSysDictVoList[j].label,
                        value:list[i].getSysDictVoList[j].value,
                    };
                    childlist.push(obj);
                }

                state.NeedData=childlist;
            }

            //居住距离标签
            if(list[i].key=='distanceTag')
            {

                let childlist=[];
                for(let j=0;j<list[i].getSysDictVoList.length;j++)
                {
                    var obj={
                        text:list[i].getSysDictVoList[j].label,
                        value:list[i].getSysDictVoList[j].value,
                    };
                    childlist.push(obj);
                }

                state.DistanceData=childlist;
            }
        }


    },

    //获取并更新商机自定义tag标签数据
    CHANGE_BUSINESS_CUSTOMTAG_DATA(state,list)
    {
        state.CustomTagData=list;
    },


    //获取商机跟进标签数据
    CHANGE_BUSINESS_FOLLOW_TAG_DATA(state,data)
    {
        state.FollowTagData=data;
    },


    CHANGE_USER_MEMBER(state, userMember) {
        state.userMember = userMember || {};
        window.localStorage.setItem("userMember", JSON.stringify(userMember));
    },
    CHANGE_USER_MENU(state, userMenu) {
        state.userMenu = userMenu || {};
        window.localStorage.setItem("userMenu", JSON.stringify(userMenu));
    },
    //设置默认门店
    GET_DEFAULT_SHOP_INFO(state, shopInfo) {
        state.defaultShopInfo = shopInfo || {};
        window.localStorage.setItem("defaultShopInfo", JSON.stringify(shopInfo));

        const currentUserInfo = state.userInfo;
        currentUserInfo.shopCode = shopInfo.shopCode;
        currentUserInfo.shopName = shopInfo.shopName;
        state.userInfo = currentUserInfo;
        window.localStorage.setItem("weChatGather", JSON.stringify(currentUserInfo));

        // 为了兼容 addCourse/index.vue     cardBag/index.vue    card/list.vue
        if (shopInfo.shopCode) {
            localStorage.setItem("courseShopCode", shopInfo.shopCode);
            localStorage.setItem("courseShopName", shopInfo.shopName);
        } else {
            localStorage.setItem("courseShopCode", '');
            localStorage.setItem("courseShopName", '');
        }
    },

    //存储并更新用户门店列表数据
    CHANGE_USER_SHOP_LIST(state,shoplist){


        if(shoplist.length>0)
        {
            state.UserShopList=shoplist;//用户门店列表数据
            state.DefaultFirstShopInfo=shoplist[0];//第一个门店数据
            state.UserShopCount=shoplist.length;//当前用户门店数量
            window.localStorage.setItem("UserShopList", JSON.stringify(shoplist));
        }
        else
        {

            try {
                //首先判断本地是否存储了标签信息 如果存取了直接使用 未获取再调接口
                if (window.localStorage.getItem("UserShopList") == null)
                {

                    let queryFlag='1';
                    if(state.userMember.roleCode=='admin')
                    {
                        queryFlag=1;
                    }
                    else
                    {
                        queryFlag=2;
                    }
                    let params = {
                        orderBy: "",

                        queryFlag:queryFlag,// 1:查所有门店 2:只查自己所属的门店   机构管理员查询2的时候没数据
                    };
                    console.log("store更新门店数据");
                    getShopList(params).then(res=>{
                        console.log("门店更新接口返回",res)
                        if (res.code == 0)
                        {
                            if(res.data.list!=null)
                            {
                                state.UserShopCount=res.data.list.length;//门店数量
                                state.UserShopList = res.data.list;//门店数据
                                state.DefaultFirstShopInfo = res.data.list[0];//第一个门店数据

                                window.localStorage.setItem("UserShopList", JSON.stringify(res.data.list));
                            }
                        }
                    });
                } else {
                    //本地有门店数据
                    let list = JSON.parse(window.localStorage.getItem("UserShopList"));
                    state.UserShopList = list;//用户门店列表数据
                    state.DefaultFirstShopInfo = list[0];//第一个门店数据
                    state.UserShopCount = list.length;//当前用户门店数量
                    // console.log("打印本地UserShopListe", JSON.parse(window.localStorage.getItem("UserShopList")));
                }

            } catch (error) {
                throw Error(error);
            }


        }


    },

    //获取用户门店
    GET_USER_SHOP_LIST(state){
        if (window.localStorage.getItem("UserShopList") != null)
        {
            //本地有门店数据
            let list = JSON.parse(window.localStorage.getItem("UserShopList"));
            state.UserShopList = list;//用户门店列表数据
            state.DefaultFirstShopInfo = list[0];//第一个门店数据
            state.UserShopCount = list.length;//当前用户门店数量

        }

        let queryFlag='1';
        if(state.userMember.roleCode=='admin')
        {
            queryFlag=1;
        }
        else
        {
            queryFlag=2;
        }
        let params = {
            orderBy: "",

            queryFlag:queryFlag,// 1:查所有门店 2:只查自己所属的门店   机构管理员查询2的时候没数据
        };
        console.log("store更新门店数据");
        getShopList(params).then(res=>{
            console.log("门店更新接口返回",res)
            if (res.code == 0)
            {
                if(res.data.list!=null)
                {
                    state.UserShopCount=res.data.list.length;//门店数量
                    state.UserShopList = res.data.list;//门店数据
                    state.DefaultFirstShopInfo = res.data.list[0];//第一个门店数据

                    window.localStorage.setItem("UserShopList", JSON.stringify(res.data.list));
                }
            }
        });
    },

    // 储存机构是否可欠费数据
    CHANge_IS_ARREARS(state, data) {
        state.isArrears = data;
        localStorage.setItem("isArrears", data);
    }
};
const getters = {
    //获取设置客户标签数据
    customerTagData: state => {
        let list=[];
        let resultlist = [];
        let TagCustomerSource = [];//客户来源
        let TagIntention = [];//意向标签
        let TagTarget = [];//需求标签
        let TagDistance = [];//居住距离标签
        if(window.localStorage.getItem("TagData") != null)
        {
            list = JSON.parse(window.localStorage.getItem("TagData"));
            state.TagData=JSON.parse(window.localStorage.getItem("TagData"));
            for (let i = 0; i < list.length; i++) {
                //客户来源
                if (list[i].key == 'customerSource') {

                    var childlist = [];
                    for (let j = 0; j < list[i].getSysDictVoList.length; j++) {
                        var obj = {
                            text: list[i].getSysDictVoList[j].label,
                            value: list[i].getSysDictVoList[j].value,
                        };
                        childlist.push(obj);
                    }

                    TagCustomerSource = {
                        text: '客户来源',
                        isMultipleChoice: false,//是否多选  默认 单选
                        choiceList: [],//选中的标签数组
                        list: childlist
                    };
                }

                //意向标签
                if (list[i].key == 'planTag') {

                    var childlist = [];
                    for (let j = 0; j < list[i].getSysDictVoList.length; j++) {
                        var obj = {
                            text: list[i].getSysDictVoList[j].label,
                            value: list[i].getSysDictVoList[j].value,
                        };
                        childlist.push(obj);
                    }

                    TagIntention = {
                        text: '意向标签',
                        isMultipleChoice: false,//是否多选  默认 单选
                        choiceList: [],//选中的标签数组
                        list: childlist
                    };
                }

                //需求标签
                if (list[i].key == 'needTag') {

                    var childlist = [];
                    for (let j = 0; j < list[i].getSysDictVoList.length; j++) {
                        var obj = {
                            text: list[i].getSysDictVoList[j].label,
                            value: list[i].getSysDictVoList[j].value,
                        };
                        childlist.push(obj);
                    }

                    TagTarget = {
                        text: '需求标签',
                        isMultipleChoice: true,//是否多选  默认 单选
                        choiceList: [],//选中的标签数组
                        list: childlist
                    };
                }

                //居住距离标签
                if (list[i].key == 'distanceTag') {

                    var childlist = [
                        // {
                        //     text: '不限',
                        //     value: -1
                        // },
                    ];
                    for (let j = 0; j < list[i].getSysDictVoList.length; j++) {
                        var obj = {
                            text: list[i].getSysDictVoList[j].label,
                            value: list[i].getSysDictVoList[j].value,
                        };
                        childlist.push(obj);
                    }

                    TagDistance = {
                        text: '居住距离标签',
                        isMultipleChoice: false,//是否多选  默认 单选
                        choiceList: [],//选中的标签数组
                        list: childlist
                    };
                }
            }
            resultlist.push(TagCustomerSource);
            resultlist.push(TagIntention);
            resultlist.push(TagTarget);
            resultlist.push(TagDistance);
            console.log("打印getter",resultlist);
        }
        else
        {
            getBusinessTag().then(res=>{
                    console.log("打印getter返回的标签数据",res)
                    if (res.code == 0) {

                        //将标签数据存到本地storage里 防止刷新页面重新调用
                        window.localStorage.setItem("TagData", JSON.stringify(res.data));
                        list=res.data;
                        state.TagData=res.data;
                        for (let i = 0; i < list.length; i++) {
                            //客户来源
                            if (list[i].key == 'customerSource') {

                                var childlist = [];
                                for (let j = 0; j < list[i].getSysDictVoList.length; j++) {
                                    var obj = {
                                        text: list[i].getSysDictVoList[j].label,
                                        value: list[i].getSysDictVoList[j].value,
                                    };
                                    childlist.push(obj);
                                }

                                TagCustomerSource = {
                                    text: '客户来源',
                                    isMultipleChoice: false,//是否多选  默认 单选
                                    choiceList: [],//选中的标签数组
                                    list: childlist
                                };
                            }

                            //意向标签
                            if (list[i].key == 'planTag') {

                                var childlist = [];
                                for (let j = 0; j < list[i].getSysDictVoList.length; j++) {
                                    var obj = {
                                        text: list[i].getSysDictVoList[j].label,
                                        value: list[i].getSysDictVoList[j].value,
                                    };
                                    childlist.push(obj);
                                }

                                TagIntention = {
                                    text: '意向标签',
                                    isMultipleChoice: false,//是否多选  默认 单选
                                    choiceList: [],//选中的标签数组
                                    list: childlist
                                };
                            }

                            //需求标签
                            if (list[i].key == 'needTag') {

                                var childlist = [];
                                for (let j = 0; j < list[i].getSysDictVoList.length; j++) {
                                    var obj = {
                                        text: list[i].getSysDictVoList[j].label,
                                        value: list[i].getSysDictVoList[j].value,
                                    };
                                    childlist.push(obj);
                                }

                                TagTarget = {
                                    text: '需求标签',
                                    isMultipleChoice: true,//是否多选  默认 单选
                                    choiceList: [],//选中的标签数组
                                    list: childlist
                                };
                            }

                            //居住距离标签
                            if (list[i].key == 'distanceTag') {

                                var childlist = [
                                    {
                                        text: '不限',
                                        value: -1
                                    },
                                ];
                                for (let j = 0; j < list[i].getSysDictVoList.length; j++) {
                                    var obj = {
                                        text: list[i].getSysDictVoList[j].label,
                                        value: list[i].getSysDictVoList[j].value,
                                    };
                                    childlist.push(obj);
                                }

                                TagDistance = {
                                    text: '居住距离标签',
                                    isMultipleChoice: false,//是否多选  默认 单选
                                    choiceList: [],//选中的标签数组
                                    list: childlist
                                };
                            }
                        }

                        resultlist.push(TagCustomerSource);
                        resultlist.push(TagIntention);
                        resultlist.push(TagTarget);
                        resultlist.push(TagDistance);
                    }
                });


        }


        return resultlist;

    },

    //获取自定义客户标签数据
    CustomTagData: state => {
        let list=[];
        let resultlist = [];

        if(window.localStorage.getItem("CustomTagData") != null)
        {
            list = JSON.parse(window.localStorage.getItem("CustomTagData"));
            state.CustomTagData=JSON.parse(window.localStorage.getItem("CustomTagData"));
            for (let i = 0; i < list.length; i++) {
                    var childlist = [];
                    for (let j = 0; j < list[i].dictList.length; j++) {
                        var obj = {
                            text: list[i].dictList[j].label,
                            value: list[i].dictList[j].value,
                        };
                        childlist.push(obj);
                    }

                    let customTagObj = {
                        text: list[i].label,
                        dictType:list[i].dictType,
                        isMultipleChoice: true,//是否多选  默认 单选
                        choiceList: [],//选中的标签数组
                        list: childlist
                    };
                    if(childlist.length>0)
                    {
                        //子项大于0的插入进去
                        resultlist.push(customTagObj);
                    }

            }

            console.log("打印自定义标签处理后的数据",resultlist);
        }
        else
        {

            getCustomTag({category:"1",isShowDisable: false,}).then(res=>{
                    console.log("打印自定义标签返回数据",res)
                    if (res.code == 0) {

                        //将标签数据存到本地storage里 防止刷新页面重新调用
                        window.localStorage.setItem("CustomTagData", JSON.stringify(res.data));
                        list=res.data;
                        state.CustomTagData=res.data;
                        for (let i = 0; i < list.length; i++) {
                            var childlist = [];
                            for (let j = 0; j < list[i].dictList.length; j++) {
                                var obj = {
                                    text: list[i].dictList[j].label,
                                    value: list[i].dictList[j].value,
                                };
                                childlist.push(obj);
                            }

                            let customTagObj = {
                                text: list[i].label,
                                dictType:list[i].dictType,
                                isMultipleChoice: true,//是否多选  默认 单选
                                choiceList: [],//选中的标签数组
                                list: childlist
                            };
                            if(childlist.length>0)
                            {
                                //子项大于0的插入进去
                                resultlist.push(customTagObj);
                            }


                        }

                        console.log("打印自定义标签处理后的数据",resultlist);

                    }
                });


        }


        return resultlist;

    },

    //获取需求标签 根据标签值  tagStr 多个逗号隔开
    getNeedTagList:(state)=>(tagStr)=>{
        let list=state.TagData;
        let valuelist=tagStr.split(',');

        let needlist=[];//需求标签
        let resultlist=[];


        for(let i=0;i<list.length;i++)
        {

            //需求标签
            if(list[i].text=='需求标签')
            {

                needlist=[];
                for(let j=0;j<list[i].dictList.length;j++)
                {
                    var obj={
                        text:list[i].dictList[j].label,
                        value:list[i].dictList[j].value,
                    };
                    needlist.push(obj);
                }
            }

        }

        for(let i=0;i<valuelist.length;i++)
        {
            for(let j=0;j<needlist.length;j++)
            {
                if(valuelist[i]==needlist[j].value)
                {
                    resultlist.push(needlist[j].text);
                }

            }
        }

        // return (tagStr)=>state.articles.find(item => item.articleId ==articleId)
        return resultlist;
    },

    //获取需求标签 根据标签值  tagValue
    getNeedTagName:(state)=>(tagValue)=>{
        try {
            if(tagValue)
            {
                let list=tagValue.split(',');


            return  state.NeedData.find(item => item.value ==list[0]).text;
            }
            else
            {
                return "";
            }
        } catch (error) {
            return "";
        }

    },

    //获取所属关系标签值  tagValue
    getOwnerShipName:(state)=>(tagValue)=>{

        let result="";
            if(tagValue)
            {





                if(window.localStorage.getItem("OwnerShipData") != null)
                {
                    let list=JSON.parse(window.localStorage.getItem("OwnerShipData"));
                    for(var i=0;i<list.length;i++)
                    {
                        if(tagValue==list[i].value)
                        {
                            result=list[i].label;
                        }
                    }

                }
                else
                {
                    getOwnershipData().then(res=>{
                        console.log("打印所属关系返回",res);
                        if(res.code==0)
                        {
                          let list=res.data;
                          window.localStorage.setItem("OwnerShipData", JSON.stringify(res.data));
                          for(var i=0;i<list.length;i++)
                            {
                                if(tagValue==list[i].value)
                                {
                                    result=list[i].label;
                                }
                            }
                        }
                    });
                }

            }
        return result;

    },

    //获取需求标签name数组 根据标签值  tagValue
    getNeedTagNameList:(state)=>(tagValue)=>{
        try {
            if(tagValue)
            {
                let list=tagValue.split(',');
                let namelist=[];
                for(var i=0;i<list.length;i++)
                {
                    namelist.push(state.NeedData.find(item => item.value ==list[i]).text);
                }

            return   namelist;
            }
            else
            {
                return [];
            }
        } catch (error) {
            return [];
        }
    },

    //获取意向标签 根据标签值  tagValue
    getIntentionTagName:(state)=>(tagValue)=>{

        try {
            if(tagValue)
            {
                if(state.IntentionData.length==0)
                {
                    state.TagData=JSON.parse(window.localStorage.getItem("TagData"));
                    for(let i=0;i<list.length;i++)
                    {
                        //客户来源
                        if(list[i].key=='customerSource')
                        {

                            var childlist=[];
                            for(let j=0;j<list[i].getSysDictVoList.length;j++)
                            {
                                var obj={
                                    text:list[i].getSysDictVoList[j].label,
                                    value:list[i].getSysDictVoList[j].value,
                                };
                                childlist.push(obj);
                            }

                            state.CustomerSource=childlist;
                        }

                        //意向标签
                        if(list[i].key=='planTag')
                        {

                            let childlist=[];
                            for(let j=0;j<list[i].getSysDictVoList.length;j++)
                            {
                                var obj={
                                    text:list[i].getSysDictVoList[j].label,
                                    value:list[i].getSysDictVoList[j].value,
                                };
                                childlist.push(obj);
                            }

                            state.IntentionData=childlist;
                        }

                        //需求标签
                        if(list[i].key=='needTag')
                        {

                            let childlist=[];
                            for(let j=0;j<list[i].getSysDictVoList.length;j++)
                            {
                                var obj={
                                    text:list[i].getSysDictVoList[j].label,
                                    value:list[i].getSysDictVoList[j].value,
                                };
                                childlist.push(obj);
                            }

                            state.NeedData=childlist;
                        }

                        //居住距离标签
                        if(list[i].key=='distanceTag')
                        {

                            let childlist=[];
                            for(let j=0;j<list[i].getSysDictVoList.length;j++)
                            {
                                var obj={
                                    text:list[i].getSysDictVoList[j].label,
                                    value:list[i].getSysDictVoList[j].value,
                                };
                                childlist.push(obj);
                            }

                            state.DistanceData=childlist;
                        }
                    }
                }
                return  state.IntentionData.find(item => item.value ==tagValue).text;
            }
            else
            {
                return "";
            }
        } catch (error) {
            return "";
        }
    },

    //获取意向标签 根据标签值  tagValue
    getIntentionTag:(state)=>(tagValue)=>{
        try {
            if(tagValue)
            {
            return  state.IntentionData.find(item => item.value ==tagValue).text;
            }
            else
            {
                return "";
            }
        } catch (error) {
            return "";
        }
    },

    //获取距离标签 根据标签值  tagValue
    getDistanceTagName:(state)=>(tagValue)=>{

        try {
            if(tagValue)
            {
                if(tagValue!='-1')
                {
                    return  state.DistanceData.find(item => item.value ==tagValue).text;
                }
                else
                {
                    return "";
                }
            }
            else
            {
                return "";
            }
        } catch (error) {
            return "";
        }

    },

    //获取来源标签 根据标签值  tagValue
    getCustomerSourceTagName:(state)=>(tagValue)=>{


        try {
            if(tagValue)
            {
                if(tagValue!='-1')
                {

                    return  state.CustomerSource.find(item => item.value ==tagValue).text;
                }
                else
                {
                    return "";
                }
            }
            else
            {
                return "";
            }
        } catch (error) {
            return "";
        }

    },


    //获取跟进记录标签数据
    getFollowTagData:state=>{
        if(state.FollowTagData=='')
        {
            let data=JSON.parse(window.localStorage.getItem("FollowTagData"));
            state.FollowTagData=data;

        }
        return state.FollowTagData;
    },

    //获取沟通标签 根据标签值  tagValue
    getGtlistTag:state=>{
        try {
            return (tagValue)=>state.FollowTagData.Gtlist.find(item => item.value ==tagValue).label;
        } catch (error) {
            console.log(error);
            return "";
        }

    },

    //获取教学问题标签 根据标签值  tagValue
    getJxlistTag:(state)=>(tagStr)=>{
        // return (tagValue)=>state.FollowTagData.Jxlist.find(item => item.value ==tagValue).label;
        try {
            let list=state.FollowTagData.Jxlist;
            let valuelist=tagStr.split(',');
            let resultlist=[];
            for(let i=0;i<valuelist.length;i++)
            {
                for(let j=0;j<list.length;j++)
                {
                    if(valuelist[i]==list[j].value)
                    {
                        let obj=list[j].label;

                        resultlist.push(obj);
                    }

                }
            }
            return resultlist.join('、');
        } catch (error) {
            console.log(error);
            return "";
        }

    },

    //获取商务问题标签 根据标签值  tagValue
    getSwlistTag:(state)=>(tagStr)=>{
        // return (tagValue)=>state.FollowTagData.Swlist.find(item => item.value ==tagValue).label;
        console.log(tagStr);
        let list=state.FollowTagData.Swlist;
        let valuelist=tagStr.split(',');
        let resultlist=[];
        for(let i=0;i<valuelist.length;i++)
        {
            for(let j=0;j<list.length;j++)
            {
                if(valuelist[i]==list[j].value)
                {
                    let obj=list[j].label;

                    resultlist.push(obj);
                }

            }
        }
        return resultlist.join('、');
    },


    //获取用户角色 从本地localStorage取
    getUserRoleName:state=>{
    //    let userMember=JSON.parse(window.localStorage.getItem("userMember")) || {};
       state.roleName=state.userMember.roleName;
       return state.userMember.roleName;
    },

    //获取用户角色编码 从本地localStorage取
    getUserRoleCode:state=>{
        // let userMember=JSON.parse(window.localStorage.getItem("userMember")) || {};
        // console.log("state.userMember.roleCode",state.userMember.roleCode);
        state.roleCode=state.userMember.roleCode;
        return state.userMember.roleCode;
     },

    //获取标签数据
    allTagData: state => {
        let list=[];
        if(window.localStorage.getItem("TagData") != null)
        {
            list = JSON.parse(window.localStorage.getItem("TagData"));
            state.TagData=JSON.parse(window.localStorage.getItem("TagData"));

        }
        else
        {
            getBusinessTag().then(res=>{
                    console.log("打印getter返回的标签数据",res)
                    if (res.code == 0) {

                        //将标签数据存到本地storage里 防止刷新页面重新调用
                        window.localStorage.setItem("TagData", JSON.stringify(res.data));
                        list=res.data;
                        state.TagData=res.data;
                    }
                });
        }

        return list;

    },
};
const actions = {
    // 获取用户信息
    /*async getUserInfo(context, cb) {
        try {
            // Toast.loading({
            //     message: "加载中...",
            //     forbidClick: true,
            //     duration: 0
            // });
            var token = tokenUtil.getToken();
            if (token === undefined) {
                console.log("token不存在-用户信息");
                context.commit("changeLogin", false);
                return;
            }
            var result = await getInfoApi();
            console.log(result.data, "用户信息");
            if (Number(result.code) === 0) {
                context.commit("handleUserInfo", result.data);
                context.commit("changeLogin", true);
                if (typeof cb === "function") {
                    cb(result.data);
                }
            } else {
                Toast.clear();
                context.commit("changeLogin", false);
            }
        } catch (error) {
            Toast.clear();
            throw Error(error);
        }
    }*/

    // 获取商机tag标签信息
    async getBusinessTag(context) {

        try {
            //首先判断本地是否存储了标签信息 如果存取了直接使用 未获取再调接口

            if (window.localStorage.getItem("TagData") == null) {
                var result = await getBusinessTag();
                if (result.code == 0) {
                    context.commit("CHANGE_BUSINESS_TAG_DATA", result.data);//获取并更新商机tag标签数据
                    //将标签数据存到本地storage里 防止刷新页面重新调用
                    window.localStorage.setItem("TagData", JSON.stringify(result.data));
                }
            }
            else
            {   //本地有标签数据
                console.log("打印本地storage",JSON.parse(window.localStorage.getItem("TagData")));
                context.commit("CHANGE_BUSINESS_TAG_DATA", JSON.parse(window.localStorage.getItem("TagData")));
            }



        } catch (error) {
            throw Error(error);
        }
    },

    // 获取商机跟进标签信息
    async getBusinessFollowTag(context) {

        try {
            //首先判断本地是否存储了标签信息 如果存取了直接使用 未获取再调接口

            if (window.localStorage.getItem("FollowTagData") == null) {
                var res = await getFollowUpTagList();

                console.log(res);
                if(res.code==0)
                {
                    let Gtlist=[];//沟通方式
                    let Jxlist=[];//教学问题
                    let Swlist=[];//商务问题
                    let FollowTagList=res.data;

                    for(var i=0;i<FollowTagList.length;i++)
                    {
                        if(FollowTagList[i].text=='沟通方式')
                        {
                            Gtlist=FollowTagList[i].dictList;

                        }

                        if(FollowTagList[i].text=='教学问题')
                        {
                            Jxlist=FollowTagList[i].dictList;


                        }

                        if(FollowTagList[i].text=='商务问题')
                        {
                            Swlist=FollowTagList[i].dictList;

                        }
                    }
                    let FollowTagData={
                        Gtlist,
                        Jxlist,
                        Swlist
                    };
                    context.commit("CHANGE_BUSINESS_FOLLOW_TAG_DATA", FollowTagData);//获取并更新商机tag标签数据
                    //将标签数据存到本地storage里 防止刷新页面重新调用
                    window.localStorage.setItem("FollowTagData", JSON.stringify(FollowTagData));
                }
            }
            else
            {   //本地有标签数据
                console.log("打印本地storage",JSON.parse(window.localStorage.getItem("FollowTagData")));
                context.commit("CHANGE_BUSINESS_FOLLOW_TAG_DATA", JSON.parse(window.localStorage.getItem("FollowTagData")));
            }
        } catch (error) {
            throw Error(error);
        }
    },

    // 获取商机tag标签信息
    async getLoadTagData(context) {

        try {
                var result = await getBusinessTag();
                if (result.code == 0) {
                    context.commit("CHANGE_BUSINESS_TAG_DATA", result.data);//获取并更新商机tag标签数据
                    //将标签数据存到本地storage里 防止刷新页面重新调用
                    window.localStorage.setItem("TagData", JSON.stringify(result.data));
                }

        } catch (error) {
            throw Error(error);
        }
    },

    // 获取商机自定义tag标签信息
    async getLoadCustomTagData(context) {

        try {
                var result = await getCustomTag({category:"1",isShowDisable: false,});
                if (result.code == 0) {

                    context.commit("CHANGE_BUSINESS_CUSTOMTAG_DATA", result.data);//获取并更新商机自定义tag标签数据
                    //将标签数据存到本地storage里 防止刷新页面重新调用
                    window.localStorage.setItem("CustomTagData", JSON.stringify(result.data));
                }

        } catch (error) {
            throw Error(error);
        }
    },

    // 获取商机跟进标签信息
    async getLoadFollowTagData(context) {

        try {

                var res = await getFollowUpTagList();
                console.log(res);
                if(res.code==0)
                {
                    let Gtlist=[];//沟通方式
                    let Jxlist=[];//教学问题
                    let Swlist=[];//商务问题
                    let FollowTagList=res.data;

                    for(var i=0;i<FollowTagList.length;i++)
                    {
                        if(FollowTagList[i].text=='沟通方式')
                        {
                            Gtlist=FollowTagList[i].dictList;

                        }

                        if(FollowTagList[i].text=='教学问题')
                        {
                            Jxlist=FollowTagList[i].dictList;


                        }

                        if(FollowTagList[i].text=='商务问题')
                        {
                            Swlist=FollowTagList[i].dictList;

                        }
                    }
                    let FollowTagData={
                        Gtlist,
                        Jxlist,
                        Swlist
                    };
                    context.commit("CHANGE_BUSINESS_FOLLOW_TAG_DATA", FollowTagData);//获取并更新商机tag标签数据
                    //将标签数据存到本地storage里 防止刷新页面重新调用
                    window.localStorage.setItem("FollowTagData", JSON.stringify(FollowTagData));
                }

        } catch (error) {
            throw Error(error);
        }
    },

    async getMerchantArrearsConfig(context) {
        try {
            let {data, code, message} = await getMerchantArrearsConfigAPI();
            console.log('data, code, message', data, code, message)
            if (code == 0) {
                context.commit('CHANge_IS_ARREARS', data && data.configValue);
            }
        } catch (e) {
            throw Error(e)
        }
    }
};
export default new Vuex.Store({
    state,
    mutations,
    getters,
    actions
});



// WEBPACK FOOTER //
// ./src/store.js